export const Types = {
    SAVE_LIST_SHOP: 'SAVE_LIST_SHOP',
}
  